export const SET_CATEGORIES = "category/SET_CATEGORIES";
export const FETCH_CATEGORIES_START = "category/FETCH_CATEGORIES_START";
export const FETCH_CATEGORIES_SUCCESS = "category/FETCH_CATEGORIES_SUCCESS";
export const FETCH_CATEGORIES_FAILED = "category/FETCH_CATEGORIES_FAILED";